import { Injectable, Injector } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { TaxResidency } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
import { take } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .getAuthentified()
      .pipe(take(1))
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generateForm(entity: TaxResidency) {
    let options: AbstractControlOptions = {};

    const formBuilderGroup = this.formBuilder.group(
      {
        ownerId: [entity?.ownerId],
        isTrue: [
          entity?.otherNif?.length > 0 ? true : false,
          Validators.required,
        ],
        otherNif: this.formBuilder.array(
          [this.formGroup()],
          Validators.nullValidator,
        ),
      },
      options,
    );

    entity?.otherNif?.length > 0 &&
      formBuilderGroup.setControl('otherNif', this.populate(entity), {
        emitEvent: false,
      });

    return formBuilderGroup;
  }
  generate(entity: TaxResidency[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      ownerId: this.userId,
    });
  }
  populate(data: TaxResidency) {
    let formArray = this.formBuilder.array([this.formGroup()]);
    if (data && data.otherNif) {
      formArray.clear();
      data.otherNif.forEach((item, index) => {
        formArray.push(
          this.formBuilder.group({
            country: [item.country],
            nif: [item.nif],
          }),
        );
      });
    }
    return formArray;
  }
  formGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      country: [''],
      nif: [''],
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return this.form.value.owners;
  }
}
